import React, { Component } from "react";
import { connect } from "react-redux";

class SubjectItemPopOver extends Component {
  getInstName = abbr => this.props.input.institutions[abbr].name;
  render() {
    const { id } = this.props;
    if (!id) return null;

    const { courses, course_prerequisites } = this.props.input;
    const subject_prerequisites = this.props.input.prerequisites;
    const course = courses[id];
    const prereqs = course_prerequisites[course.course_code] || {};
    const keys_to_titles = [{ key: "S", title: "Subject prerequisites" }];

    return (
      <div className="course-area-details">
        <div className="margin-bottom">
          <h1 className="course-area-details-title"> {course.title} </h1>
          <h2 className="course-area-details-uni">
            {this.getInstName(course.institution)}
          </h2>
        </div>

        {keys_to_titles.map((element, index) => {
          const prerequisites = prereqs[element.key];

          if (!prerequisites || prerequisites.length <= 0) {
            return null;
          }

          return (
            <div key={index}>
              <div className="title">{element.title}</div>
              <p>
                {prerequisites
                  .map(id => subject_prerequisites[id].description)
                  .join("; ")}
              </p>
            </div>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = store => {
  const { userCourses } = store.coursesReducer;
  const { input } = store.inputReducer;
  return { userCourses, input };
};

export default connect(mapStateToProps)(SubjectItemPopOver);
